module.exports = __webpack_public_path__ + "static/images/circle-cross._cpjMHv.svg";